<template>
  <div>
    <v-navigation-drawer
      v-if="this.$store.getters.authenticated"
      v-model="sidebar.display"
      app
    >
      <v-list
        v-if="false"
        color="blue-darken-3"
        theme="dark"
      >
        <v-list-item class="px-2" >
          <v-list-item-title class="title">
            {{ this.$store.state.admin.name }}
          </v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list
        nav
      >
        <v-list-item
          to="/"
        >
          <template #prepend>
            <v-icon>mdi-view-dashboard</v-icon>
          </template>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list
        nav
      >
        <v-list-group
          v-if="$store.getters.authenticated"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-domain"
            >
              <v-list-item-title>Accounts</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            to="/accounts"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-domain</v-icon>
          </template>
          <v-list-item-title>Accounts</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/users"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-account-group</v-icon>
          </template>
          <v-list-item-title>Users</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/admins"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-shield-account</v-icon>
          </template>
          <v-list-item-title>Admins</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-divider></v-divider>

      <v-list
        nav
      >
        <v-list-group
          v-if="$store.getters.authenticated"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-wrench"
            >
              <v-list-item-title>Maintenance</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            to="/server-metrics"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-thermometer</v-icon>
          </template>
          <v-list-item-title>Server Metrics</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/logs"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-text-box-outline</v-icon>
          </template>
          <v-list-item-title>Logs</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/database"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-database-outline</v-icon>
          </template>
          <v-list-item-title>Database</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/queues"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-tray-full</v-icon>
          </template>
          <v-list-item-title>Queues</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/performance"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-speedometer</v-icon>
          </template>
          <v-list-item-title>Performance</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-divider></v-divider>

      <v-list
        nav
      >
        <v-list-group
          v-if="$store.getters.authenticated"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-robot-angry"
            >
              <v-list-item-title>Bots</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            to="/bot-servers"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-server</v-icon>
          </template>
          <v-list-item-title>Servers</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/bots"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-robot</v-icon>
          </template>
          <v-list-item-title>Instances</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/bot-queue"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-format-list-checks</v-icon>
          </template>
          <v-list-item-title>Queue</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/bot-errors"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-bug</v-icon>
          </template>
          <v-list-item-title>Errors</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/bot-view"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-desktop-classic</v-icon>
          </template>
          <v-list-item-title>View</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/bot-grid"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-view-grid</v-icon>
          </template>
          <v-list-item-title>Grid</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-divider
        v-if="$store.getters.authenticated"
      ></v-divider>

      <v-list
        v-if="$store.getters.authenticated"
        nav
      >
        <v-list-group>
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-robot"
            >
              <v-list-item-title>AI</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            to="/ai/conversations"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-robot</v-icon>
            </template>
            <v-list-item-title>AI Chats</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/ai/llm-requests"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-format-list-checks</v-icon>
            </template>
            <v-list-item-title>AI Requests Queue</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/ai/message-feedback"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-thumb-up-outline</v-icon>
            </template>
            <v-list-item-title>Webwalker AI Feedback</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/sarah-walker/message-feedback"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-thumb-up-outline</v-icon>
            </template>
            <v-list-item-title>Sarah Walker Feedback</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item
          to="/sarah-walker/conversations"
        >
          <template #prepend>
            <v-icon>mdi-crown</v-icon>
          </template>
          <v-list-item-title>Sarah Walker</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list
        nav
      >
        <v-list-item
          to="/workflows"
        >
          <template #prepend>
            <v-icon>mdi-cogs</v-icon>
          </template>
          <v-list-item-title>Workflows</v-list-item-title>
        </v-list-item>

        <v-list-group
          v-if="$store.getters.authenticated"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-account-box-multiple"
            >
              <v-list-item-title>Contacts</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            to="/contacts"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-account-box-multiple</v-icon>
          </template>
          <v-list-item-title>Contacts</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/companies"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-briefcase</v-icon>
          </template>
          <v-list-item-title>Companies</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/contact-lists"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-table-account</v-icon>
          </template>
          <v-list-item-title>Contact Lists</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/contacts-import"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-cloud-upload</v-icon>
          </template>
          <v-list-item-title>Import from File</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          v-if="$store.getters.authenticated"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-bullseye-arrow"
            >
              <v-list-item-title>CRM</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            to="/task-boards"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-bullseye-arrow</v-icon>
          </template>
          <v-list-item-title>Tasks</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/notes"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-note</v-icon>
          </template>
          <v-list-item-title>Notes</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/tags"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-tag</v-icon>
          </template>
          <v-list-item-title>Tags</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          v-if="$store.getters.authenticated"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-linkedin"
            >
              <v-list-item-title>LinkedIn</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            to="/linkedin"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-account-box-multiple</v-icon>
          </template>
          <v-list-item-title>Accounts</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/linkedin-profiles"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-contacts</v-icon>
          </template>
          <v-list-item-title>Profiles</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/linkedin-conversations"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-forum</v-icon>
          </template>
          <v-list-item-title>Conversations</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/linkedin-searches"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-account-search</v-icon>
          </template>
          <v-list-item-title>Searches</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/linkedin-personas"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-account-box-outline</v-icon>
          </template>
          <v-list-item-title>Personas</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/linkedin-priority-companies"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-office-building-outline</v-icon>
          </template>
          <v-list-item-title>Priority Companies</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/linkedin-connections"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-account-multiple</v-icon>
          </template>
          <v-list-item-title>Connections</v-list-item-title>
          </v-list-item>

          <v-list-group
            class="pl-2"
            sub-group
          >
            <template #activator="{ props }">
            <v-list-item
              v-bind="props"
            >
              <v-list-item-title>Invitations</v-list-item-title>
            </v-list-item>
            </template>
            <v-list-item
              to="/linkedin-invitations-received"
              class="pl-6"
            >
              <template #prepend>
            <v-icon>mdi-account-multiple-plus</v-icon>
          </template>
          <v-list-item-title>Received</v-list-item-title>
            </v-list-item>

            <v-list-item
              to="/linkedin-invitations-sent"
              class="pl-6"
            >
              <template #prepend>
            <v-icon>mdi-account-multiple-plus-outline</v-icon>
          </template>
          <v-list-item-title>Sent</v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-item
            to="/linkedin-suggestions"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-account-question</v-icon>
          </template>
          <v-list-item-title>Suggestions</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/linkedin-views"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-target-account</v-icon>
          </template>
          <v-list-item-title>Views</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/linkedin-groups"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-account-group</v-icon>
          </template>
          <v-list-item-title>Groups</v-list-item-title>
          </v-list-item>

          <v-list-group
            class="pl-2"
            sub-group
          >
            <template #activator="{ props }">
            <v-list-item
              v-bind="props"
            >
              <v-list-item-title>Company Page</v-list-item-title>
            </v-list-item>
            </template>

            <v-list-item
              class="pl-6"
              :disabled="true"
            >
              <template #prepend>
            <v-icon>mdi-note-text</v-icon>
          </template>
          <v-list-item-title>Posts</v-list-item-title>
            </v-list-item>

            <v-list-item
              class="pl-6"
              :disabled="true"
            >
              <template #prepend>
            <v-icon>mdi-briefcase-plus</v-icon>
          </template>
          <v-list-item-title>Invitations Sent</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list-group>
      </v-list>

      <v-divider></v-divider>

      <v-list
        nav
      >
        <v-list-group
          v-if="$store.getters.authenticated"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-wrench"
            >
              <v-list-item-title>Integrations</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            to="/integrations"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-api</v-icon>
          </template>
          <v-list-item-title>API</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/webhooks"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-webhook</v-icon>
          </template>
          <v-list-item-title>Webhooks</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-divider></v-divider>

      <v-list
        nav
      >
        <v-list-group
          v-if="$store.getters.authenticated"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-chart-box"
            >
              <v-list-item-title>Reports</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            to="/overview"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-calendar</v-icon>
          </template>
          <v-list-item-title>Overview</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/reports"
            class="pl-6"
          >
            <template #prepend>
            <v-icon>mdi-chart-areaspline</v-icon>
          </template>
          <v-list-item-title>Charts</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-divider></v-divider>

      <v-list
        nav
      >
        <v-list-item
          to="/settings"
        >
          <template #prepend>
            <v-icon>mdi-tune</v-icon>
          </template>
          <v-list-item-title>Settings</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

    </v-navigation-drawer>

    <v-app-bar
      color="blue"
    theme="dark"
      elevation="0"
      app
    density="compact"
      :absolute="!this.$store.getters.authenticated"
      :hide-on-scroll="!this.$store.getters.authenticated"
    >
      <v-app-bar-nav-icon
        v-if="this.$store.getters.authenticated"
        @click="sidebar.display = !sidebar.display"
      ></v-app-bar-nav-icon>

      <v-toolbar-title v-if="!smallMobileScreen420"></v-toolbar-title>

      <v-spacer></v-spacer>

      <main-nav-notifications
        v-if="$store.getters.authenticated"
      ></main-nav-notifications>

      <v-btn
        v-if="$store.getters.authenticated"
        to="/settings"
        icon
        class="mx-1"
        size="small"
      >
        <v-icon size="small">mdi-account-circle</v-icon>
      </v-btn>

      <div
        v-if="$store.getters.authenticated"
      >
        <v-tooltip location="bottom" v-if="$store.state.isDarkMode" >
          <template #activator="{ props }">
            <v-btn v-bind="props" size="small" icon @click="$store.dispatch('switchDarkMode', false)">
              <v-icon size="small" color="yellow" class="mr-1">mdi-moon-waxing-crescent</v-icon>
            </v-btn>
          </template>
          <span>Disable dark mode</span>
        </v-tooltip>
        <v-tooltip location="bottom" v-else >
          <template #activator="{ props }">
            <v-btn v-bind="props" size="small" icon @click="$store.dispatch('switchDarkMode', true)">
              <v-icon size="small" color="yellow">mdi-white-balance-sunny</v-icon>
            </v-btn>
          </template>
          <span>Enable dark mode</span>
        </v-tooltip>
      </div>

      <v-divider
        v-if="$store.getters.authenticated"
        v-show="!this.isAuthView"
        vertical
        class="ml-2 mr-0 mr-sm-4"
      ></v-divider>

      <v-btn
        class="main-nav-btn mx-2"
        size="small"
        variant="text" v-if="!this.$store.getters.authenticated"
        :to="{name: 'Login'}"
      >
        <v-icon class="mr-1" size="small">mdi-login</v-icon>
        Login
      </v-btn>
      <v-btn
        class="mx-2"
        icon
        size="small"
        v-if="this.$store.getters.authenticated"
        @click="logoutConfirmation = true"
      >
        <v-icon size="small">mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <base-dialog-confirmation
      v-model="logoutConfirmation"
      prompt="Do you really want to logout?"
      confirm-text="Logout"
      confirm-color="red"
      @confirm="logout"
      @cancel="logoutConfirmation = false"
    ></base-dialog-confirmation>
  </div>
</template>

<script>
import MainNavNotifications from '@/components/layout/MainNavNotifications.vue';

/**
 * Compact / mobile navigation drawer (vs top MainNav).
 *
 * ## When it mounts
 * App shows this when `isSidebarLayout` (Vuetify smAndDown); top nav is hidden then.
 *
 * ## Structure
 * Template is mostly `v-list-group` blocks mirroring router domains
 * (Accounts, CRM, Tasks, Workflows, Bots, LinkedIn, Integrations, AI).
 * Script is thin: drawer open state, auth/public route check, `logout` emit to App.
 */
export default {
  name: 'MainNavSidebar',

  components: {
    MainNavNotifications,
  },

  data: () => ({
    logoutConfirmation: false,
    sidebar: {
      display: false,
    },
  }),

  computed: {
    dropdownTheme() {
      return this.$store.state.isDarkMode ? 'dark' : 'light';
    },

    isAuthView() {
      // Check if on auth pages (login, sign up, password reset, etc)
      if (this.$route && this.$route.meta) {
        return this.$route.meta.public;
      }
      return false;
    },
    smallMobileScreen420() {
      return window.screen.width < 420;
    },
  },

  methods: {
    logout: function () {
      this.$emit('logout');
    },
  },
};
</script>
